module.exports = __webpack_public_path__ + "static/media/educator.885b148e.png";